import React from 'react';
import MITable from '../MITable';
import { GridViewComponents } from 'grid-views';

interface GridBodyRendererProps {
    gridData: any[];
    columns: any[];
    isLoading: boolean;
    onSortColumn: any;
    order: any;
    orderBy: any;
    legendConfig: any;
    dragAndDrop: any;
    handleDropRow: any;
    massActions: any;
    reloadGridData: any;
    onColumnResize: any;
    massActionsProps: any;
    setPopupUrl: any;
    setPopupConfig: any;
    height?: any;
    setPopupType: any;
    setPopupMode: any;
    setPopupComponent: any;
    setPopupComponentProps: any;
    t: any;
    multilines: any;
    defaultRowHeight: any;
    columnsWidthPixels: any;
    setShowLoader: any;
    gridName: string;
    visibleColumns: any;
    rowExtraInfoConfig: any;
    gridReorderLoading: boolean;
    form: any;
    setGridDataChanged: any;
    uid: string;
    filtersValue: any;
    customLegend: any;
    autoRowHeight: any;
    gridEntityType: any;
    gridView: string;
}

const MAX_DATA_LENGTH = 100;

export const GridBodyRenderer: React.FC<GridBodyRendererProps> = ({
    gridData,
    columns,
    isLoading,
    onSortColumn,
    order,
    orderBy,
    legendConfig,
    dragAndDrop,
    handleDropRow,
    massActions,
    reloadGridData,
    onColumnResize,
    massActionsProps,
    setPopupUrl,
    setPopupConfig,
    height,
    setPopupType,
    setPopupMode,
    setPopupComponent,
    setPopupComponentProps,
    t,
    multilines,
    defaultRowHeight,
    columnsWidthPixels,
    setShowLoader,
    gridName,
    visibleColumns,
    rowExtraInfoConfig,
    gridReorderLoading,
    form,
    setGridDataChanged,
    uid,
    filtersValue,
    customLegend,
    autoRowHeight,
    gridEntityType,
    gridView,
}) => {
    const gridBodyComponentProps = {
        data: gridData,
        columns: columns,
        isLoading: isLoading,
        onSortColumn: onSortColumn,
        order: order,
        orderBy: orderBy,
        legendConfig: legendConfig,
        dragAndDrop: dragAndDrop,
        handleDropRow: handleDropRow,
        massActionsConfig: massActions,
        reloadGridData: reloadGridData,
        onColumnResize: onColumnResize,
        massActionsProps: massActionsProps,
        setPopupUrl: setPopupUrl,
        setPopupConfig: setPopupConfig,
        autoHeight: gridData.length <= MAX_DATA_LENGTH,
        height: height,
        setPopupType: setPopupType,
        setPopupMode: setPopupMode,
        setPopupComponent: setPopupComponent,
        setPopupComponentProps: setPopupComponentProps,
        t: t,
        multilines: multilines,
        defaultRowHeight: defaultRowHeight,
        columnsWidth: columnsWidthPixels,
        setShowLoader: setShowLoader,
        gridName: gridName,
        visibleColumns: visibleColumns,
        rowExtraInfoConfig: rowExtraInfoConfig,
        gridReorderLoading,
        form: form,
        setGridDataChanged: setGridDataChanged,
        uid: uid,
        filtersValue: filtersValue,
        customLegend: customLegend,
        autoRowHeight: autoRowHeight,
        gridEntityType: gridEntityType,
    };

    const bodyComponent = GridViewComponents[gridView] ?? MITable;
    return React.createElement(bodyComponent, gridBodyComponentProps);
};
